import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { csmWidgetLayout } from '@jira/customer-service__csm-support-widget-layout/src/csmWidgetLayout.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import {
	composeLayouts,
	layoutWithCondition,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmHubSetupResource } from '@jira/router-resources__customer-service-common/src/csmHubSetupResource.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { csmExperienceDetailsRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceDetailsRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';
import { helpCenterSettingDetailsAppPageEntryPoint } from './ui/details/index.tsx';

export const csmExperienceDetailsRouteEntry: Route = createEntry(csmExperienceDetailsRoute, () => ({
	group: 'helpcenter-settings',
	perfMetricKey: 'help-center-settings.csm-experience-details',
	layout: layoutWithCondition(
		() => fg('csm-support-widget-in-csm'),
		composeLayouts(serviceProjectLayout, csmWidgetLayout),
		serviceProjectLayout,
	),
	navigation: {
		menuId: MenuIdCustomerExperiences,
		sidebarId: SidebarIdCsmApp,
	},
	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? helpCenterSettingDetailsAppPageEntryPoint
			: notFoundPageEntrypoint;
	},
	resources: [
		...getCustomerServiceL1NavigationResources(),
		...getCsmExperiencesResources(),
		csmHubSetupResource,
	],
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
